var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { DefaultTooltipDirectionStyles } from './DefaultTooltipDirectionStyles';
import { TooltipDirections } from './TooltipDirections';
export var DirectionalTooltipStylesByTooltipDirection = (_a = {},
    _a[TooltipDirections.TOP] = {
        directionalContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.directionalContainerStyles), { justifyContent: 'center' }),
        tooltipContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipContainerStyles), { bottom: function (showDirectionalArrow) { return (showDirectionalArrow ? 'calc(100% + 11px)' : '1px'); } }),
        tooltipArrowStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipArrowStyles), { boxShadowSizing: '4px 4px 13px -3px', top: '100%', left: '50%' }),
    },
    _a[TooltipDirections.BOTTOM] = {
        directionalContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.directionalContainerStyles), { justifyContent: 'center' }),
        tooltipContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipContainerStyles), { top: function (showDirectionalArrow) { return (showDirectionalArrow ? 'calc(100% + 11px)' : '1px'); } }),
        tooltipArrowStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipArrowStyles), { boxShadowSizing: '-4px -4px 13px -3px', top: '0%', left: '50%' }),
    },
    _a[TooltipDirections.RIGHT] = {
        directionalContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.directionalContainerStyles), { alignItems: 'center' }),
        tooltipContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipContainerStyles), { left: function (showDirectionalArrow) { return (showDirectionalArrow ? 'calc(100% + 11px)' : '1px'); } }),
        tooltipArrowStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipArrowStyles), { boxShadowSizing: '-2px 4px 13px -3px', top: '50%', left: '0%' }),
    },
    _a[TooltipDirections.LEFT] = {
        directionalContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.directionalContainerStyles), { alignItems: 'center' }),
        tooltipContainerStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipContainerStyles), { right: function (showDirectionalArrow) { return (showDirectionalArrow ? 'calc(100% + 11px)' : '1px'); } }),
        tooltipArrowStyles: __assign(__assign({}, DefaultTooltipDirectionStyles.tooltipArrowStyles), { boxShadowSizing: '4px -2px 13px -3px', top: '50%', left: '100%' }),
    },
    _a);
//# sourceMappingURL=DirectionalTooltipStylesByTooltipDirection.js.map